// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2L7 2V4H4L4 7L2 7L2 2ZM11 2L16 2V7H14V4L11 4V2ZM9 9H22V22H9V9ZM4 10V13H7V15H2V10H4Z"}}]};

const PasteFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'paste-filled',
    ref,
    icon: element,
  },
));

PasteFilledIcon.displayName = 'PasteFilledIcon';

export default PasteFilledIcon;
